<style lang="scss">
    @import '~@/abstracts/_variables.scss';

    .icon {
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-image: url('/img/base-icons/ic-badge-big.svg');

        &.is-background-left {
            background-position: left center;
        }

        &.is-inline {
            display: inline-block;
            vertical-align: middle;
            width: 0.875rem;
            height: 0.875rem;
            position: relative;
            top: -1px;
            right: auto;
            bottom: auto;
            left: auto;
        }

        &.is-large {
            width: 1.375rem;
            height: 1.375rem;
        }

        &-error-message  {
            background-image: url('/img/base-icons/ic-error-message.svg')
        }

        &-success-message {
            background-image: url('/img/base-icons/ic-success-message.svg')
        }

        &-info-message {
            background-image: url('/img/base-icons/ic-error-message.svg')
        }

        &-cross {
            background-image: url('/img/base-icons/ic-cross.svg')
        }
    }
</style>


<template>
    <i class="icon" :class="`icon-${icon}`" :style="style"></i>
</template>

<script>
    export default {
        name: 'BaseIcon',
        props: {
            icon: String,
            base: String
        },

        computed: {
            style () {
                return this.base ? { backgroundImage: `url(${this.base})` } : {}
            }
        }
    }
</script>
